<template>
  <div class="card">
    <div class="card-header text-center py-2">{{ titulo }}</div>
    <div class="card-body" v-if="verForm">
      <form @submit.prevent="guardar">
        <div class="form-group row mb-1">
          <label for="selectProducto" class="col-sm-2 col-form-label">Producto:</label>
          <div class="col-sm-4">
            <select id="selectProducto" class="form-control form-control-sm" v-model="form.carta_producto_id" :required="true">
              <option value="">---------</option>
              <option v-for="i in productos" :key="i.id" :value="i.id">{{ i.nombre }}</option>
            </select>
          </div>
           <label for="inputCantidad" class="col-sm-2 col-form-label">Cantidad mínima:</label>
          <div class="col-sm-4">
            <input type="number" step="0.01" class="form-control form-control-sm" v-model="form.cantidad_minima" :required="true">
          </div>
        </div>
        <div class="form-group row mb-0">
          <div class="col-sm-12 text-right">
            <button
              type="button"
              class="btn btn-sm btn-secondary mr-1"
              v-if="reg !== ''"
              @click.prevent="limpiar"
            >
              Nuevo
            </button>
            <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnGuardar"
              ></span>
              <span class="sr-only" v-if="btnGuardar">
                {{ reg === '' ? 'Guardando...':'Actualizando...' }}
              </span>
              <span v-if="!btnGuardar">
                {{ reg === '' ? 'Guardar':'Actualizar' }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-muted p-1">
      <span v-if="inicio">Buscando...</span>
      <div class="input-group input-group-sm mb-0" v-else>
        <input 
          type="text" 
          class="form-control" 
          v-model="listaTermino"
          placeholder="Buscar por descripcion" 
          aria-label="Buscar por descripcion" 
          aria-describedby="btnBuscarNombre"
        >
        <div class="input-group-append">
          <button 
            class="btn btn-outline-secondary px-3" 
            type="button" 
            @click="verForm = !verForm"
            id="btnBuscarNombre"
          >
            <font-awesome-icon icon="angle-up" v-if="verForm"/>
            <font-awesome-icon icon="angle-down" v-else/>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="!inicio">
      <table class="table table-sm">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Producto</th>
            <th scope="col">Cantidad</th>
            <th scope="col" width="70px">
              <button class="btn btn-sm btn-danger" @click="anularKit">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnAnular"
                ></span>
                <span class="sr-only" v-if="btnAnular">
                  Anulando
                </span>
                <span v-else>
                  Anular
                </span>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, idx) in filtrada" :key="i.id">
            <th scope="row">{{ idx + 1 }}</th>
            <td><a href="#" @click.prevent="editar(idx)">{{ i.nombre }}</a></td>
            <td>{{ i.cantidad_minima }}</td>
            <td class="text-center">
              <input type="checkbox" v-model="anular" :value="i.id">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import CartaCatalogo from '../mixins/CartaCatalogo.js';
  import ManteAccion from '../mixins/ManteAccion.js';

  export default {
    name: 'ManteCartaKit',
    mixins: [CartaCatalogo,ManteAccion],
    data: () => ({
      titulo: 'KIT',
      productos: [],
      anular: [],
      btnAnular: false
    }),
    created () {
      this.nombre = 'producto_contenedor';
      this.listaFiltrar = 'nombre';
      this.getProductosKit();
    },
    methods: {
      getProductosKit () {
        axios
        .get(this.UrlBase+'/catalogo/get_producto?format=json&kit=1')
        .then(r => {
          this.productos = r.data.lista;
        })
        .catch(e => {
          alert(e);
        });
      },
      anularKit () {
        if (this.anular.length == 0) {
          this.showErrorMsg({message: 'Debe seleccionar un producto'});
          return false;
        }

        if (confirm("¿Está seguro?")) {
          this.btnAnular = true;

          axios
          .post(this.UrlBase+'/anular/kit', {kits: this.anular})
          .then(res => {
            if (res.data.exito) {
              this.anular = [];
              this.buscar();
            } else {
              this.showErrorMsg({message: res.data.mensaje});
            }
            this.btnAnular = false;
          }).catch(e => {
            alert('Anular '+e);
          })
        }
      }
    }
  }
</script>